import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IndexContainer } from './smartfocus-components';
import SmartfocusPanel from './smartfocus-panel';
import Typography from '../../../../common-components/Typography';
import content from '../../../../constants/content';
import vmTheme from '../../../../constants/theme';
import { font } from '../../../../constants/font';
import { STATIC_PATH } from '../../../../constants/config';
import { setPropertyWindow } from '../../../../redux/actions/appUtils';
import useMobileDetection from '../../../../helper/hooks/useMobileDetection';

const SmartFocusIndex = () => {
    const theme = useSelector((state) => state.app.get("theme"));
    const isMobile = useMobileDetection();

    const dispatch = useDispatch();
    const handlePanelClose = () => {
        dispatch(setPropertyWindow({
            component: "",
            type: "",
            isTextColor: false,
            isOpened: false
        }));
    };

    return (
        <div>
            <IndexContainer>
                <div style={{
                    display: "flex", justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "14px",
                    cursor: "pointer",
                    padding: "17px",
                    borderBottom: "1px solid #ededed"
                }}>
                    <Typography
                        content={content.SMART_FOCUS}
                        margin={isMobile ? "0px" : "0px 0px 0px 17px !important"}
                        color={vmTheme[theme].panelPrimaryColor}
                        font={font.boldBase}
                        height="19px"
                    />
                    <img src={`${STATIC_PATH}close_icon.svg`} alt="zoomClose" onClick={handlePanelClose} style={{ width: "24px", height: "24px" }} />
                </div>
                <SmartfocusPanel />
            </IndexContainer>
        </div>
    );
};

export default SmartFocusIndex;